import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../api";
import QRCode from "qrcode";

function BlanchisserieDetail() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [qrCode, setQrCode] = useState("");

  // ==========================================================
  // CHARGEMENT DE L'ENCAISSEMENT
  // ==========================================================

  useEffect(() => {
    const charger = async () => {
      try {
        const response = await api.get(
          `/blanchisserie/${id}`
        );

        setData(response.data);
      } catch (error) {
        console.error(
          "Erreur chargement encaissement:",
          error
        );
      } finally {
        setLoading(false);
      }
    };

    charger();
  }, [id]);

  // ==========================================================
  // QR CODE DE VÉRIFICATION
  // ==========================================================

  useEffect(() => {
    if (!data?.encaissement?.numero) return;

    const verificationUrl =
      `https://app.immalta.com/verification/blanchisserie/${data.encaissement.numero}`;

    QRCode.toDataURL(verificationUrl, {
      width: 160,
      margin: 1,
    })
      .then(setQrCode)
      .catch((error) =>
        console.error(
          "Erreur QR code:",
          error
        )
      );
  }, [data]);

  // ==========================================================
  // FORMATAGE
  // ==========================================================

  const formatMoney = (montant) =>
    Number(montant).toLocaleString("fr-FR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  const formatDate = (date) =>
    new Date(date).toLocaleString("fr-FR", {
      dateStyle: "short",
      timeStyle: "short",
    });

  // ==========================================================
  // CHARGEMENT
  // ==========================================================

  if (loading) {
    return (
      <div style={styles.message}>
        Chargement...
      </div>
    );
  }

  if (!data?.encaissement) {
    return (
      <div style={styles.message}>
        Encaissement introuvable.
      </div>
    );
  }

  const encaissement = data.encaissement;
  const lignes = data.lignes || [];

  // ==========================================================
  // AFFICHAGE
  // ==========================================================

  return (
    <div style={styles.page}>

      {/* ====================================================
          BARRE D'ACTIONS — NON IMPRIMÉE
      ==================================================== */}

      <div
        className="no-print"
        style={styles.actionsTop}
      >

        <button
          style={styles.backButton}
          onClick={() =>
            navigate("/blanchisserie")
          }
        >
          ← Retour
        </button>

        <button
          style={styles.printButton}
          onClick={() =>
            window.open(
              `/blanchisserie/${id}/impression`,
              "_blank"
            )
          }
        >
          🖨️ Imprimer
        </button>

      </div>

      {/* ====================================================
          REÇU
      ==================================================== */}

      <div
        id="blanchisserie-recu"
        className="blanchisserie-recu"
        style={styles.receipt}
      >

        {/* ==================================================
            EN-TÊTE
        ================================================== */}

        <div style={styles.header}>

          <div style={styles.logo}>
            ALTA
          </div>

          <div style={styles.company}>
            IMMEUBLE
          </div>

          <div style={styles.type}>
            RECU DES PRESTATIONS
          </div>

        </div>

        <div style={styles.separator} />

        {/* ==================================================
            INFORMATIONS
        ================================================== */}

        <div style={styles.info}>

          <div>
            <strong>Reçu :</strong>{" "}
            {encaissement.numero}
          </div>

          <div>
            <strong>Date :</strong>{" "}
            {formatDate(
              encaissement.date_encaissement
            )}
          </div>

          <div>
            <strong>Client :</strong>{" "}
            {encaissement.client_nom ||
              "Client de passage"}
          </div>

          <div>
            <strong>Encaissé par :</strong>{" "}
            {encaissement.encaisseur_nom ||
              "Utilisateur non identifié"}
          </div>

        </div>

        <div style={styles.separator} />

        {/* ==================================================
            PRESTATIONS
        ================================================== */}

        <table style={styles.table}>

          <thead>
            <tr>

              <th style={styles.th}>
                Désignation
              </th>

              <th
                style={{
                  ...styles.th,
                  ...styles.right,
                }}
              >
                Qté
              </th>

              <th
                style={{
                  ...styles.th,
                  ...styles.right,
                }}
              >
                P.U.
              </th>

              <th
                style={{
                  ...styles.th,
                  ...styles.right,
                }}
              >
                Total
              </th>

            </tr>
          </thead>

          <tbody>

            {lignes.map((ligne) => (

              <tr key={ligne.id}>

                <td style={styles.td}>
                  {ligne.designation}
                </td>

                <td
                  style={{
                    ...styles.td,
                    ...styles.right,
                  }}
                >
                  {ligne.quantite}
                </td>

                <td
                  style={{
                    ...styles.td,
                    ...styles.right,
                  }}
                >
                  {formatMoney(
                    ligne.prix_unitaire
                  )}
                </td>

                <td
                  style={{
                    ...styles.td,
                    ...styles.right,
                  }}
                >
                  {formatMoney(
                    ligne.total
                  )}
                </td>

              </tr>

            ))}

          </tbody>

        </table>

        <div style={styles.separator} />

        {/* ==================================================
            TOTAL
        ================================================== */}

        <div style={styles.total}>

          <span>
            TOTAL
          </span>

          <strong>
            {formatMoney(
              encaissement.montant
            )}{" "}
            {encaissement.devise}
          </strong>

        </div>

        {/* ==================================================
            MODE DE PAIEMENT
        ================================================== */}

        <div style={styles.payment}>

          <strong>
            Mode de paiement :
          </strong>{" "}

          {encaissement.mode_paiement}

        </div>

        {/* ==================================================
            OBSERVATION
        ================================================== */}

        {encaissement.observation && (
          <div style={styles.observation}>

            <strong>
              Observation :
            </strong>{" "}

            {encaissement.observation}

          </div>
        )}

        {/* ==================================================
            QR CODE — BAS À DROITE
        ================================================== */}

        {qrCode && (
          <div style={styles.qrSection}>

            <img
              src={qrCode}
              alt="QR Code de vérification"
              style={styles.qrCode}
            />

            <div style={styles.qrText}>
              Scanner pour vérifier ce reçu
            </div>

          </div>
        )}

        {/* ==================================================
            FOOTER
        ================================================== */}

        <div style={styles.footer}>

          <p>
            Merci pour votre confiance.
          </p>

          <small>
            Reçu d'encaissement des prestations
          </small>

        </div>

      </div>

      {/* ====================================================
          CSS IMPRESSION THERMIQUE 80 MM
      ==================================================== */}

      <style>
        {`
          @media print {

            @page {
              size: 80mm auto;
              margin: 0;
            }

            html,
            body {
              width: 80mm;
              margin: 0 !important;
              padding: 0 !important;
              background: #fff !important;
            }

            body {
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }

            .no-print {
              display: none !important;
            }

            #root {
              width: 80mm !important;
              margin: 0 !important;
              padding: 0 !important;
            }

            .blanchisserie-recu {
              width: 72mm !important;
              max-width: 72mm !important;
              margin: 0 auto !important;
              padding: 4mm 2mm !important;
              box-sizing: border-box !important;

              background: #fff !important;
              box-shadow: none !important;
              border-radius: 0 !important;

              font-family:
                Arial,
                Helvetica,
                sans-serif !important;

              font-size: 10px !important;
              color: #000 !important;
            }

            .blanchisserie-recu * {
              color: #000 !important;
            }

            .blanchisserie-recu .header {
              text-align: center !important;
            }

            .blanchisserie-recu .separator {
              border-top:
                1px dashed #000 !important;

              margin:
                8px 0 !important;
            }

            .blanchisserie-recu table {
              width: 100% !important;
              font-size: 9px !important;
            }

            .blanchisserie-recu th {
              padding:
                4px 2px !important;

              border-bottom:
                1px solid #000 !important;
            }

            .blanchisserie-recu td {
              padding:
                4px 2px !important;

              border-bottom:
                1px dotted #aaa !important;
            }

            .blanchisserie-recu .logo {
              font-size: 20px !important;
            }

            .blanchisserie-recu .company {
              font-size: 11px !important;
            }

            .blanchisserie-recu .type {
              margin-top: 5px !important;
              font-size: 14px !important;
            }

            .blanchisserie-recu .info {
              font-size: 9px !important;
              line-height: 1.5 !important;
            }

            .blanchisserie-recu .total {
              font-size: 15px !important;
              font-weight: bold !important;
            }

            .blanchisserie-recu .payment {
              margin-top: 8px !important;
              font-size: 9px !important;
            }

            .blanchisserie-recu .observation {
              margin-top: 6px !important;
              font-size: 9px !important;
            }

            .blanchisserie-recu .qrSection {
              display: flex !important;
              flex-direction: column !important;
              align-items: flex-end !important;

              margin-top: 10px !important;
              width: 100% !important;
            }

            .blanchisserie-recu .qrCode {
              width: 26mm !important;
              height: 26mm !important;
            }

            .blanchisserie-recu .qrText {
              margin-top: 2px !important;
              font-size: 7px !important;
              text-align: right !important;
            }

            .blanchisserie-recu .footer {
              margin-top: 10px !important;
              padding-top: 6px !important;

              border-top:
                1px dashed #000 !important;

              font-size: 8px !important;
              text-align: center !important;
            }

            .blanchisserie-recu .footer p {
              margin:
                4px 0 !important;
            }

            .blanchisserie-recu .footer small {
              font-size: 7px !important;
            }

          }
        `}
      </style>

    </div>
  );
}

// ============================================================
// STYLES ÉCRAN
// ============================================================

const styles = {

  page: {
    padding: "24px",
    background: "#f5f6f8",
    minHeight: "100vh",
  },

  actionsTop: {
    maxWidth: "700px",
    margin: "0 auto 20px",
    display: "flex",
    justifyContent: "space-between",
  },

  backButton: {
    padding: "10px 16px",
    borderRadius: "8px",
    border: "1px solid #d1d5db",
    background: "#fff",
    cursor: "pointer",
  },

  printButton: {
    padding: "10px 18px",
    borderRadius: "8px",
    border: "none",
    background: "#1d4ed8",
    color: "#fff",
    cursor: "pointer",
    fontWeight: "600",
  },

  receipt: {
    width: "100%",
    maxWidth: "650px",
    margin: "0 auto",
    background: "#fff",
    padding: "32px",
    boxSizing: "border-box",
    boxShadow:
      "0 2px 10px rgba(0,0,0,0.08)",
  },

  header: {
    textAlign: "center",
  },

  logo: {
    fontSize: "24px",
    fontWeight: "800",
    letterSpacing: "2px",
  },

  company: {
    fontSize: "14px",
    letterSpacing: "3px",
  },

  type: {
    marginTop: "12px",
    fontSize: "18px",
    fontWeight: "700",
  },

  separator: {
    borderTop: "1px dashed #999",
    margin: "18px 0",
  },

  info: {
    lineHeight: "1.8",
    fontSize: "14px",
  },

  table: {
    width: "100%",
    borderCollapse: "collapse",
    fontSize: "13px",
  },

  th: {
    padding: "8px 4px",
    borderBottom:
      "1px solid #ddd",
    textAlign: "left",
  },

  td: {
    padding: "8px 4px",
    borderBottom:
      "1px solid #eee",
  },

  right: {
    textAlign: "right",
  },

  total: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontSize: "20px",
  },

  payment: {
    marginTop: "18px",
    fontSize: "14px",
  },

  observation: {
    marginTop: "12px",
    fontSize: "13px",
  },

  qrSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    marginTop: "24px",
  },

  qrCode: {
    width: "110px",
    height: "110px",
  },

  qrText: {
    marginTop: "5px",
    fontSize: "9px",
    color: "#666",
    textAlign: "right",
  },

  footer: {
    textAlign: "center",
    marginTop: "30px",
    color: "#555",
  },

  message: {
    padding: "50px",
    textAlign: "center",
  },
};

export default BlanchisserieDetail;